export default __webpack_public_path__ + "static/media/illustration.8aeb45a4.svg";